import React from 'react'

function GetHrsTime(TAT,type) {
    let strHours = ''
    let strMinutes = ''
    let newTAT = Number(TAT)
    if(newTAT < 0){
        return false
    }else{
        let hours = ''
        if(newTAT >= 60){
            hours = Math.floor((newTAT / 60))
        }else{
            hours = "0"
        }
        if(hours < 10){
            strHours = '0'+hours
        }else{
            strHours = hours
        }
        
        let minutes = (newTAT % 60)
        if(minutes < 10){
            strMinutes = '0'+minutes
        }else{
            strMinutes = minutes
        }
let str;

if(type == 1){
     str = strHours+'h '+strMinutes+'m'
}else{
  str = strHours+':'+strMinutes+' Hrs'
}
        
        return str;
    }
}

export default GetHrsTime
